import {
  addDays,
  addHours,
  addMinutes,
  addMonths,
  addSeconds,
  addWeeks,
  addYears,
  startOfDay,
  startOfDecade,
  startOfHour,
  startOfMinute,
  startOfMonth,
  startOfSecond,
  startOfWeek,
  startOfYear,
} from 'date-fns';
import type { CalendarResolution } from './types';

export const DECADE_RESOLUTION: CalendarResolution = {
  resolve: (date) => ({
    from: startOfDecade(date),
    to: startOfDecade(addYears(date, 10)),
  }),
  start: (date) => startOfDecade(date),
  end: (date) => startOfDecade(addYears(date, 10)),
};

export const YEAR_RESOLUTION: CalendarResolution = {
  resolve: (date) => ({
    from: startOfYear(date),
    to: startOfYear(addYears(date, 1)),
  }),
  start: (date) => startOfYear(date),
  end: (date) => startOfYear(addYears(date, 1)),
};

export const MONTH_RESOLUTION: CalendarResolution = {
  resolve: (date) => ({
    from: startOfMonth(date),
    to: startOfMonth(addMonths(date, 1)),
  }),
  start: (date) => startOfMonth(date),
  end: (date) => startOfMonth(addMonths(date, 1)),
};

export const WEEK_RESOLUTION: CalendarResolution = {
  resolve: (date) => ({
    from: startOfWeek(date, { weekStartsOn: 1 }),
    to: startOfWeek(addWeeks(date, 1), { weekStartsOn: 1 }),
  }),
  start: (date) => startOfWeek(date, { weekStartsOn: 1 }),
  end: (date) => startOfWeek(addWeeks(date, 1), { weekStartsOn: 1 }),
};

export const DAY_RESOLUTION: CalendarResolution = {
  resolve: (date) => ({
    from: startOfDay(date),
    to: startOfDay(addDays(date, 1)),
  }),
  start: (date) => startOfDay(date),
  end: (date) => startOfDay(addDays(date, 1)),
};

export const HOUR_RESOLUTION: CalendarResolution = {
  resolve: (date) => ({
    from: startOfHour(date),
    to: startOfHour(addHours(date, 1)),
  }),
  start: (date) => startOfHour(date),
  end: (date) => startOfHour(addHours(date, 1)),
};

export const MINUTE_RESOLUTION: CalendarResolution = {
  resolve: (date) => ({
    from: startOfMinute(date),
    to: startOfMinute(addMinutes(date, 1)),
  }),
  start: (date) => startOfMinute(date),
  end: (date) => startOfMinute(addMinutes(date, 1)),
};

export const SECOND_RESOLUTION: CalendarResolution = {
  resolve: (date) => ({
    from: startOfSecond(date),
    to: startOfSecond(addSeconds(date, 1)),
  }),
  start: (date) => startOfSecond(date),
  end: (date) => startOfSecond(addSeconds(date, 1)),
};
